<div style="padding: 10px 10px">
    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="field">
        <div class="settings-title">Show "Delete user" button?</div>
        <p-inputSwitch [(ngModel)]="configService.config.showDeleteUser"></p-inputSwitch>
    </div>

    <div class="field">
        <div class="settings-title">Upload PDF for Receipt OCR</div>
        <input 
            type="file" 
            #pdfInput 
            style="display: none" 
            accept=".pdf,application/pdf" 
            (change)="onPdfSelected($event)" />
        
        <div class="pdf-upload-container">
            <div *ngIf="selectedPdf" class="pdf-preview">
                <div class="pdf-info">
                    <i class="pi pi-file-pdf" style="font-size: 2rem; color: #dc3545;"></i>
                    <div class="pdf-details">
                        <p class="pdf-name">{{ selectedPdf.name }}</p>
                        <p class="pdf-size">{{ getFileSize(selectedPdf.size) }}</p>
                    </div>
                </div>
                <div class="pdf-actions">
                    <button 
                        pButton 
                        type="button" 
                        label="Remove" 
                        icon="pi pi-times" 
                        class="p-button-text p-button-danger"
                        [disabled]="isUploading"
                        (click)="removePdf()">
                    </button>
                    <button 
                        pButton 
                        type="button" 
                        label="Upload" 
                        icon="pi pi-upload" 
                        class="p-button-primary"
                        [disabled]="isUploading"
                        (click)="uploadPdf()">
                    </button>
                </div>
            </div>
            <div *ngIf="!selectedPdf" class="upload-placeholder">
                <p>No PDF file selected</p>
                <button 
                    pButton 
                    type="button" 
                    label="Choose PDF" 
                    icon="pi pi-file" 
                    class="p-button-outlined mt-2"
                    (click)="pdfInput.click()">
                </button>
            </div>
            <div *ngIf="isUploading" class="upload-progress">
                <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
                <p>Uploading & recognizing PDF...</p>
            </div>
        </div>
    </div>

    <div class="field" *ngIf="isShowTestExceptionButton">
        <div class="settings-title" style="cursor: pointer;" (click)="generateTestException()">Test exception</div>        
    </div>
</div>
<p-toast position="top-right"></p-toast>
